export const requireDynamicFlag = (countryCode) =>
  `https://cdn.nextretreat.com/common/flags/${countryCode.toLowerCase()}.png?format=webp`
